import { useQuery } from '@tanstack/react-query'
import { groupsApi } from '@shared/api/groups'

export function useGroups(assistantId: string | null) {
  return useQuery({
    queryKey: ['groups', assistantId],
    queryFn: () => groupsApi.getByAssistantId(assistantId!),
    enabled: !!assistantId,
  })
}

export function useGroup(groupId: string | null) {
  return useQuery({
    queryKey: ['group', groupId],
    queryFn: () => groupsApi.getById(groupId!),
    enabled: !!groupId,
  })
}
